const fundDeclaration = () => import('@/modules/acceptance/PageDeclaration')
const fundEplist = () => import('@/modules/acceptance/PageEplist')
const fundTxsqlbList = () => import('@/modules/acceptance/PageTxsqlbList')
const fundStatisticsList = () => import('@/modules/acceptance/PageStatistics')
const fundLoanlimitList = () => import('@/modules/acceptance/PageLoanlimit')
const fundTrunoverloan = () => import('@/modules/acceptance/pageTrunoverloan')
const importSPTLoanData = () => import('@/modules/acceptance/importSPTLoanData')
const fundPool = () => import('@/modules/acceptance/pagePool')
const fundPoolSource = () => import('@/modules/acceptance/pagePoolSource')
export default [
  {
    path: '/acceptance/pjtx',
    name: 'fundDeclaration',
    component: fundDeclaration,
    meta: {
      title: '票据贴现列表',
      isBlack: true
    },
  },
  {
    path: '/acceptance/qymdk',
    name: 'fundEplist',
    component: fundEplist,
    meta: {
      title: '企业名单库',
      isBlack: true
    },
  },

  {
    path: '/acceptance/txsqlb',
    name: 'fundTxsqlbList',
    component: fundTxsqlbList,
    meta: {
      title: '贴现申请列表',
      isBlack: true
    },
  },

  {
    path: '/acceptance/tjbb',
    name: 'fundStatisticsList',
    component: fundStatisticsList,
    meta: {
      title: '统计分析',
    },
  },

  {
    path: '/acceptance/cydbxegl',
    name: 'fundLoanlimitList',
    component: fundLoanlimitList,
    meta: {
      title: '创业担保限额管理',
      isBlack: true
    },
  },

  {
    path: '/acceptance/cydbsjdr',
    name: 'fundTrunoverloan',
    component: fundTrunoverloan,
    meta: {
      title: '富民创业贷数据导入',
      isBlack: true
    },
  },
  {
    path: '/acceptance/cydbsj',
    name: 'fundTrunoverloanjjgl',
    component: fundTrunoverloan,
    meta: {
      title: '富民创业贷数据导入',
    },
  },
  {
    path: '/ImportSPTLoanData',
    name: 'ImportSPTLoanData',
    component: importSPTLoanData,
    meta: {
      title: '创业担保数据导入',
      isBlack: true
    },
  },

  {
    path: '/acceptance/jjjbxx',
    name: 'fundPool',
    component: fundPool,
    meta: {
      title: '基金基本信息',
      isBlack: true
    },
  },

  {
    path: '/acceptance/jjlyxx',
    name: 'fundPoolSource',
    component: fundPoolSource,
    meta: {
      title: '基金来源信息',
      isBlack: true
    },
  },
]
